// Only library routes use the first-stage shell. Editor, catalog detail and native
// chat routes retain their existing layout, including titlebar and chat styling.
const libraries = new Set([
  "/reports", "/chats", "/factsheets", "/overview", "/files", "/projects",
  "/automations", "/integrations", "/templates", "/agents", "/approvals",
  "/catalog/reports", "/catalog/dashboards", "/catalog/workflows",
])

export function v2ShellPath(pathname: string) {
  return libraries.has(pathname.replace(/\/$/, ""))
}

export function reportCreationRequested(search: Record<string, unknown>) {
  return search.create === "1" || !!search.definition_id || !!search.source_workspace_id || !!search.source_dashboard_id
}
